module.exports = __webpack_public_path__ + "media/images/icon/icons8-Clear Symbol-5caa7d06e0c438748d6918b21f7ebaf4.png";